import { useEffect } from 'react';

export const useModifyPageTitle = (title?: string): void => {
	useEffect(() => {
		document.title = title ? `InsideOut: ${title}` : `InsideOut`;
	}, [title]);
};
